import { combineEpics } from 'redux-observable';

// services
import { Service as AnalyticsService } from 'modules/analytics-provider';

// epics
import {
    analyticsEpicCreator,
    mainPage,
    setLanguage,
    setUserAnalyticsData,
    cleanLoginAnalyticsData,
} from 'modules/analytics-provider/analytics-provider.epic';

// constants
import { REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY } from 'modules/language-provider/language-provider.constants';
import { REMOVE_LOGIN_SESSION, SET_LOGIN_SESSION } from 'modules/login/login.constants';
import { Analytics } from './analytics';
import { OPTION_LANGUAGE_ANALYTICS_ATTRIBUTES } from 'modules/footer/footer.constants';
import { OPERATION_ENDING_STATUS } from 'modules/end-operation/end-operation.constants';
import {
    EVENT_SET_DATA,
    EVENT_SET_OWNERSHIP_DATA,
    EVENT_SET_OWNERSHIP_ERROR
} from 'modules/event-manager/event-manager.constants';
import { ownershipErrorAction } from 'modules/event-manager/event-manager.actions';
import { ERROR_TYPES } from 'modules/event-manager/event-manager-error';
import { STEP_LOGIN } from '../../router/router.constants';
import { WIDGET_ACTIVE_VIEW_TRANSITION } from 'modules/router/router.constants';
import { SET_PLATFORM } from '../platform-selection/platform-selection.constants';

// types
import { IAction } from 'types/action';
import { IEpic } from 'types/epic';

export const mainPageEpic = mainPage([EVENT_SET_DATA], Analytics.Constants);
export const setLanguageEpic = setLanguage([REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY], OPTION_LANGUAGE_ANALYTICS_ATTRIBUTES);
const setUserAnalyticsDataEpic = setUserAnalyticsData([SET_LOGIN_SESSION]);
const cleanLoginAnalyticsDataEpic = cleanLoginAnalyticsData([REMOVE_LOGIN_SESSION]);

export const loginPageEpic = analyticsEpicCreator(
    [WIDGET_ACTIVE_VIEW_TRANSITION],
    (action: IAction): void => {
        if (action.payload === STEP_LOGIN) {
            AnalyticsService.updateAnalyticalData({
                flowStep: Analytics.Constants.loginPage.name,
            });
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.loginPage.name,
                siteSubSection: Analytics.Constants.loginPage.subSection,
                errorType: ''
            });
        }
    }
);

export const successPageEpic: IEpic = analyticsEpicCreator(
    [EVENT_SET_OWNERSHIP_DATA],
    (): void => {
        AnalyticsService.updateAnalyticalData({
            flowStep: Analytics.Constants.successPage.name,
        });
        AnalyticsService.sendPageEvent({
            pageName: Analytics.Constants.successPage.name,
            siteSubSection: Analytics.Constants.successPage.subSection,
            errorType: ''
        });
    }
);

export const alreadyClaimedPageEpic: IEpic = analyticsEpicCreator(
    [EVENT_SET_OWNERSHIP_ERROR],
    (action: ownershipErrorAction): void => {
        if (action.payload.type === ERROR_TYPES.ALREADY_OPTED) {
            AnalyticsService.updateAnalyticalData({
                flowStep: Analytics.Constants.alreadyClaimedPage.name,
            });
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.alreadyClaimedPage.name,
                siteSubSection: Analytics.Constants.alreadyClaimedPage.subSection,
                errorType: ''
            });
        }
    }
);

export const endOperationPageEpic: IEpic = analyticsEpicCreator(
    [OPERATION_ENDING_STATUS],
    (action: IAction): void => {
        if (!action.payload.isValid) {
            AnalyticsService.updateAnalyticalData({
                flowStep: Analytics.Constants.endOperationPage.name,
            });
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.endOperationPage.name,
                siteSubSection: Analytics.Constants.endOperationPage.subSection,
                errorType: ''
            });
        }
    }
);

export const errorPageEpic: IEpic = analyticsEpicCreator(
    [EVENT_SET_OWNERSHIP_ERROR],
    (): void => {
        AnalyticsService.updateAnalyticalData({
            flowStep: Analytics.Constants.errorPage.name,
        });
        AnalyticsService.sendPageEvent({
            pageName: Analytics.Constants.errorPage.name,
            siteSubSection: Analytics.Constants.errorPage.subSection,
            errorType: ''
        });
    }
);

export const platformSelectionEpic: IEpic = analyticsEpicCreator(
    [SET_PLATFORM],
    (action: IAction): void => {
        AnalyticsService.updateAnalyticalData({
            platformSelection: action.payload,
        });
    }
);

export const analyticsEpics: IEpic = combineEpics(
    mainPageEpic,
    setLanguageEpic,
    setUserAnalyticsDataEpic,
    cleanLoginAnalyticsDataEpic,
    loginPageEpic,
    successPageEpic,
    endOperationPageEpic,
    alreadyClaimedPageEpic,
    errorPageEpic,
    platformSelectionEpic,
);

export default analyticsEpics;
